import { WSAlertProps } from "@wingspanhq/fe-component-library";
import { PropsWithChildren } from "react";
import { useHistory } from "react-router-dom";
import { openInNewTab } from "../../../../shared/utils/openInNewTab";
import { NotificationHandleType } from "../Notifications";
import { notificationAlertOverridesMap } from "./overrides";
import { NotificationWithGroup } from "../../selectors/selectorAlerts";

export function notificationToAlert(
  notification: NotificationWithGroup,
  history: ReturnType<typeof useHistory>
) {
  const baseProps: PropsWithChildren<WSAlertProps> = {
    title: notification.subject,
    theme: "info",
    icon: "info-circle",
    children: notification.message,
    action:
      notification.actionTitle && notification.actionURL
        ? {
            text: notification.actionTitle,
            onClick: () => {
              const { hostname, pathname, search, hash } = new URL(
                notification.actionURL!
              );

              if (hostname !== window.location.hostname) {
                openInNewTab(notification.actionURL!);
                return;
              }

              history.push(pathname + search + hash);
            }
          }
        : undefined
  };

  const overrideFn =
    notificationAlertOverridesMap[
      notification.handle as NotificationHandleType
    ];

  if (overrideFn) {
    const override = overrideFn(notification, history);
    return { ...baseProps, ...override };
  }

  return baseProps;
}
